import { SortType } from '@/enums/sort-type.enum';
import { SortState } from '@/interfaces/states/sort-state.interface';

export default {
  type: (state: SortState): SortType => state.type,
};
